// Estimacion de costo mensual: cantidad x precio, con los precios que define la empresa (no hay precios incluidos).
// Solo cuenta lo que se puede deducir del diagrama (instancias EC2/RDS, NAT, balanceadores, discos EBS, ElastiCache) y los
// costos manuales que se anoten en un objeto (data.costoMensual). No incluye trafico, almacenamiento de S3, ni descuentos.
import { mapa, ancestros } from "modAws/grafoUtil";

const prop = (d, k) => { const p = (d.props || []).find(([x]) => x === k); return p ? String(p[1]) : null; };
const conocido = (v) => (v && !v.includes("‹") ? v : null);
const veces = (d) => {
    if (Number(d.cuenta) > 1) return Number(d.cuenta);
    const m = /×(\d+)$/.exec(d.label || "");
    return m ? Number(m[1]) : 1;
};

// Un concepto por objeto: { nodo, clave, titulo, unidad, cantidad } o { nodo, clave, titulo, fijo } para los manuales.
export const entradasDeCosto = (nodes) => {
    const salida = [];
    for (const n of nodes) {
        const d = n.data || {};
        if (n.type !== "aws") continue;
        if (typeof d.costoMensual === "number" && d.costoMensual >= 0) { salida.push({ nodo: n.id, clave: `manual:${n.id}`, titulo: `${d.label || d.servicio} (manual)`, unidad: "mes", cantidad: 1, fijo: d.costoMensual }); continue; }
        const n_ = veces(d), obj = d.objeto || "";
        if (d.servicio === "ec2" && obj === "Instancias") {
            const t = conocido(prop(d, "instance_type"));
            salida.push({ nodo: n.id, clave: `ec2:${t || "sin-tipo"}`, titulo: `EC2 ${t || "(tipo sin definir)"}`, unidad: "mes", cantidad: n_ });
        } else if ((d.servicio === "rds" || d.servicio === "aurora") && obj === "Instancias") {
            const t = conocido(prop(d, "instance_class"));
            salida.push({ nodo: n.id, clave: `rds:${t || "sin-tipo"}`, titulo: `Base de datos ${t || "(clase sin definir)"}`, unidad: "mes", cantidad: n_ * (prop(d, "multi_az") === "true" ? 2 : 1) });
        } else if (d.servicio === "vpc" && obj === "NAT Gateways") salida.push({ nodo: n.id, clave: "nat", titulo: "NAT Gateway", unidad: "mes", cantidad: n_ });
        else if (d.servicio === "elb" && obj === "Application LB") salida.push({ nodo: n.id, clave: "alb", titulo: "Application Load Balancer", unidad: "mes", cantidad: n_ });
        else if (d.servicio === "elb" && obj === "Network LB") salida.push({ nodo: n.id, clave: "nlb", titulo: "Network Load Balancer", unidad: "mes", cantidad: n_ });
        else if (d.servicio === "ebs") {
            const gb = Number(conocido(prop(d, "size")));
            if (gb > 0) { const t = conocido(prop(d, "type")) || "gp3"; salida.push({ nodo: n.id, clave: `ebs:${t}`, titulo: `Disco EBS ${t}`, unidad: "GB-mes", cantidad: gb * n_ }); }
        } else if (d.servicio === "elasticache" && obj.startsWith("Clusters")) {
            const t = conocido(prop(d, "node_type")), nodos = Number(conocido(prop(d, "num_cache_nodes"))) || 1;
            salida.push({ nodo: n.id, clave: `elasticache:${t || "sin-tipo"}`, titulo: `ElastiCache ${t || "(tipo sin definir)"}`, unidad: "mes", cantidad: n_ * nodos });
        }
    }
    return salida;
};

// precios: { clave: numero }. Devuelve filas por concepto (para editar), el total y el desglose por capa.
export const resumirCosto = (entradas, precios, nodes) => {
    const porId = mapa(nodes);
    const capaDe = (id) => { const n = porId[id]; const c = n && ancestros(n, porId).find(p => p.data && p.data.tipo === "capa"); return c ? c.data.label : null; };
    const filas = new Map(), capas = new Map();
    let total = 0, sinPrecio = 0;
    for (const e of entradas) {
        const precio = e.fijo !== undefined ? e.fijo : precios[e.clave];
        const sub = precio === undefined ? null : precio * e.cantidad;
        if (!filas.has(e.clave)) filas.set(e.clave, { clave: e.clave, titulo: e.titulo, unidad: e.unidad, cantidad: 0, precio, fijo: e.fijo !== undefined, subtotal: 0, nodos: 0 });
        const f = filas.get(e.clave);
        f.cantidad += e.cantidad; f.nodos++;
        const nom = capaDe(e.nodo) || "(sin capa)";
        if (!capas.has(nom)) capas.set(nom, { capa: nom, total: 0, sinPrecio: 0 });
        if (sub === null) { sinPrecio++; capas.get(nom).sinPrecio++; }
        else { total += sub; f.subtotal += sub; capas.get(nom).total += sub; }
    }
    return {
        filas: [...filas.values()].sort((a, b) => Number(a.fijo) - Number(b.fijo) || a.titulo.localeCompare(b.titulo)),
        total, sinPrecio, porCapa: capas.size > 1 || (capas.size === 1 && !capas.has("(sin capa)")) ? [...capas.values()].sort((a, b) => b.total - a.total) : [],
    };
};
